import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Enable Alpine.js for Blade navigation toggles (e.g., mobile hamburger)
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();
